export const tabsVariants = {
    primary: {
        tabsWrapper: 'rounded-full flex bg-white',
        tab: 'font-agrandir cursor-pointer border-0 bg-transparent p-1.5 rounded-full text-lg font-medium text-center whitespace-nowrap overflow-hidden truncate disabled:opacity-80 disabled:cursor-auto',
        tabSelected: 'font-agrandir cursor-auto text-green-900 border-1 border-green-700 bg-transparent p-1.5 rounded-full text-lg font-bold text-center whitespace-nowrap overflow-hidden truncate',
    },
    secondary: {
        tabsWrapper: 'rounded-full flex bg-white',
        tab: 'font-agrandir cursor-pointer border-0 bg-transparent p-1.5 rounded-full text-lg font-medium text-center whitespace-nowrap overflow-hidden truncate disabled:opacity-80 disabled:cursor-auto',
        tabSelected: 'font-agrandir cursor-auto text-green-900 border-1 border-green-700 bg-transparent p-1.5 rounded-full text-lg font-bold text-center whitespace-nowrap overflow-hidden truncate',
    },
};